export default __webpack_public_path__ + "static/media/Clan Bound Bracers of the Four Winds.5960fff8.jpg";